import React, { useState } from "react";
import { GoToBack }  from "../../../src/components/ui/GoToBack header/GoToBackR5 copy.js";
import { Button, FormGroup, FormControl, ControlLabel, Row, Col,InputGroup } from "react-bootstrap";
import Axios from "axios";
import { toast } from "react-toastify";
import { API_BASE_PATH } from "../../constants/workerConstants"; // adjust path
import { useHistory } from "react-router-dom";

const AddEmployee = () => {
  const history = useHistory();
  const [employee, setEmployee] = useState({
    emailId: "",
    userRole: "5",
    deviceType: "web",
    firstName: "",
    lastName: "",
    nickName: "",
    age: "",
    address: "",
    securityQuestion: [
      "what is your pet Name?",
      "What is your birth place?",
      "What is your favorite color?",
    ],
    selectedQuestion: "",
    answer: "",
    phno: "",
    username: "",
    password: "",
    confirmPassword: "",
    imei: "",
    vin: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEmployee({ ...employee, [name]: value });
    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!employee.firstName.trim()) {
      newErrors.firstName = "First name is required";
    }
    if (!employee.lastName.trim()) {
      newErrors.lastName = "Last name is required";
    }
    if (!employee.emailId.trim()) {
      newErrors.emailId = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(employee.emailId)) {
      newErrors.emailId = "Please enter a valid email";
    }
    if (!employee.username.trim()) {
      newErrors.username = "Username is required";
    } else if (employee.username.length < 3) {
      newErrors.username = "Username must be at least 3 characters";
    }
    if (!employee.nickName.trim()) {
      newErrors.nickName = "Nickname is required";
    }
    if (!employee.age) {
      newErrors.age = "Age is required";
    } else if (employee.age < 18 || employee.age > 100) {
      newErrors.age = "Age must be between 18 and 100";
    }
    if (!employee.address.trim()) {
      newErrors.address = "Address is required";
    }
    if (!employee.phno.trim()) {
      newErrors.phno = "Phone number is required";
    } else if (!/^\d{10}$/.test(employee.phno.replace(/[-\s]/g, ""))) {
      newErrors.phno = "Please enter a valid 10-digit phone number";
    }
    if (!employee.imei.trim()) {
      newErrors.imei = "IMEI is required";
    } else if (!/^\d{15}$/.test(employee.imei.replace(/[-\s]/g, ""))) {
      newErrors.imei = "Please enter a valid 15-digit IMEI number";
    }
    if (!employee.vin.trim()) {
      newErrors.vin = "VIN is required";
    } else if (!/^[A-Z0-9]{17}$/.test(employee.vin.replace(/[-\s]/g, ""))) {
      newErrors.vin = "Please enter a valid 17-alphanumeric characters VIN";
    }
    if (!employee.selectedQuestion) {
      newErrors.selectedQuestion = "Please select a security question";
    }
    if (!employee.answer.trim()) {
      newErrors.answer = "Answer is required";
    }
    if (!employee.password) {
      newErrors.password = "Password is required";
    } else if (employee.password.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
    }
    if (!employee.confirmPassword) {
      newErrors.confirmPassword = "Please confirm your password";
    } else if (employee.password !== employee.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
const handleSubmit = (e) => {
  e.preventDefault();

  if (!validateForm()) return; // use your existing validation

  const data = {
    firstName: employee.firstName,
    lastName: employee.lastName,
    emailId: employee.emailId,
    username: employee.username,
    nickName: employee.nickName,
    age: employee.age,
    address: employee.address,
    phno: employee.phno,
    password: employee.password,
    confirmPassword: employee.confirmPassword,
    securityQuestion: employee.selectedQuestion,
    answer: employee.answer,
    deviceType: employee.deviceType,
    userRole: employee.userRole,
    imei: employee.imei,
    vin: employee.vin,
  };

  Axios.post(`${API_BASE_PATH}/user/register`, data, {
    headers: { "Content-Type": "application/json" },
  })
    .then((res) => {
      toast.success("Employee added successfully!");
      console.log(res.data);
      // Reset form
      setEmployee({
        emailId: "",
        userRole: "5",
        deviceType: "web",
        firstName: "",
        lastName: "",
        nickName: "",
        age: "",
        address: "",
        securityQuestion: [
          "what is your pet Name?",
          "What is your birth place?",
          "What is your favorite color?",
        ],
        selectedQuestion: "",
        answer: "",
        phno: "",
        username: "",
        password: "",
        confirmPassword: "",
        imei: "",
        vin: "",
      });
      setErrors({});
      history.push("/auth/login");
    })
    .catch((err) => {
      toast.error(err.response?.data?.responseMessage || "Something went wrong!");
      console.error(err);
    });
};
const stylee = {
  marginBottom: "25px",
  background: "#FFFFFF",
  border: "none",
  boxShadow: "0px 2px 1px rgb(0 0 0 /25%)",
  borderRadius: " 11px",
};

  // const roundedInput = {
  //   borderRadius: "150px",
  //   padding: "10px",
  // };

  return (
    <>
    <div >
     <GoToBack><h5 style={{ fontWeight: 700, color: "#303030", textAlign: "center" }}> Add Employee</h5></GoToBack>
    </div>
    <div className="AddEmployee" style={{ padding: "0px 280px", minWidth: "400px" }}>
       <h5  style={{ fontWeight: 700, color: "#303030", textAlign: "center" }}>
        Employee Registration Form
      </h5>
      <form onSubmit={handleSubmit} >
        <>
      
      <br />
      <br />
        </>
        {/* First row */}
        <Row  style={{
            background: "#ECECEC",
            padding: "1rem",
            marginTop: "-2rem",
            borderRadius: " 5px",
          }}>
          <Col md={6}>
            <FormGroup>
              <ControlLabel style={{ marginBottom: "6px",marginTop: "10px" }}>
                First Name<span className="text-danger">*</span>
              </ControlLabel>
              <FormControl
              //  style={roundedInput}
                type="text"
                name="firstName"
                value={employee.firstName}
                onChange={handleChange}
                placeholder="Enter first name"
                 style={stylee}
              />
              {errors.firstName && (
                <span className="text-danger small">{errors.firstName}</span>
              )}
            </FormGroup>
          </Col>

          <Col md={6}>
            <FormGroup>
              <ControlLabel style={{ marginBottom: "6px",marginTop: "10px" }}>
                Last Name<span className="text-danger">*</span>
              </ControlLabel>
              <FormControl
              //  style={roundedInput}
                type="text"
                name="lastName"
                value={employee.lastName}
                onChange={handleChange}
                placeholder="Enter last name"
                style={stylee}
              />
              {errors.lastName && (
                <span className="text-danger small">{errors.lastName}</span>
              )}
            </FormGroup>
          </Col>
        </Row>

        {/* Second row */}
        <Row  style={{
            background: "#ECECEC",
            padding: "1rem",
            marginTop: "-2rem",
            borderRadius: " 5px",
          }}>
          <Col md={6}>
            <FormGroup>
              <ControlLabel style={{ marginBottom: "6px",marginTop: "10px" }}>
                Email<span className="text-danger">*</span>
              </ControlLabel>
              <FormControl
               // style={roundedInput}
                style={stylee}
                type="email"
                name="emailId"
                value={employee.emailId}
                onChange={handleChange}
                placeholder="Enter email"
              />
              {errors.emailId && (
                <span className="text-danger small">{errors.emailId}</span>
              )}
            </FormGroup>
          </Col>

          <Col md={6}>
            <FormGroup>
              <ControlLabel style={{ marginBottom: "6px",marginTop: "10px" }}>
                Username<span className="text-danger">*</span>
              </ControlLabel>
              <FormControl
                //style={roundedInput}
                 style={stylee}
                type="text"
                name="username"
                value={employee.username}
                onChange={handleChange}
                placeholder="Enter username"
              />
              {errors.username && (
                <span className="text-danger small">{errors.username}</span>
              )}
            </FormGroup>
          </Col>
        </Row>

        {/* Third row */}
        <Row  style={{
            background: "#ECECEC",
            padding: "1rem",
            marginTop: "-2rem",
            borderRadius: " 5px",
          }}>
          <Col md={6}>
            <FormGroup>
              <ControlLabel style={{ marginBottom: "6px",marginTop: "10px" }}>
                Nickname<span className="text-danger">*</span>
              </ControlLabel>
              <FormControl
                style={stylee}
                type="text"
                name="nickName"
                value={employee.nickName}
                onChange={handleChange}
                placeholder="Enter nickname"
              />
              {errors.nickName && (
                <span className="text-danger small">{errors.nickName}</span>
              )}
            </FormGroup>
          </Col>

          <Col md={6}>
            <FormGroup>
              <ControlLabel style={{ marginBottom: "6px",marginTop: "10px" }}>
                Age<span className="text-danger">*</span>
              </ControlLabel>
              <FormControl
              //  style={roundedInput}
                 style={stylee}
                type="number"
                name="age"
                value={employee.age}
                onChange={handleChange}
                placeholder="Enter age"
              />
              {errors.age && (
                <span className="text-danger small">{errors.age}</span>
              )}
            </FormGroup>
          </Col>
        </Row>

        {/* Fourth row */}
        <Row  style={{
            background: "#ECECEC",
            padding: "1rem",
            marginTop: "-2rem",
            borderRadius: " 5px",
          }}>
          <Col md={6}>
            <FormGroup>
              <ControlLabel style={{ marginBottom: "6px",marginTop: "10px" }}>
                Address<span className="text-danger">*</span>
              </ControlLabel>
              <FormControl
                style={stylee}
               //style={roundedInput}
                type="text"
                name="address"
                value={employee.address}
                onChange={handleChange}
                placeholder="Enter address"
              />
              {errors.address && (
                <span className="text-danger small">{errors.address}</span>
              )}
            </FormGroup>
          </Col>
     
          <Col md={6}>
            <FormGroup>
              <ControlLabel style={{ marginBottom: "6px",marginTop: "10px" }}>
                Phone Number<span className="text-danger">*</span>
              </ControlLabel>
              <FormControl
                style={stylee}
               // style={roundedInput}
                type="tel"
                name="phno"
                value={employee.phno}
                onChange={handleChange}
                placeholder="Enter phone number"
              />
              {errors.phno && (
                <span className="text-danger small">{errors.phno}</span>
              )}
            </FormGroup>
          </Col>

          <Col md={6}>
            <FormGroup>
              <ControlLabel style={{ marginBottom: "6px",marginTop: "10px" }}>IMEI<span className="text-danger">*</span></ControlLabel>
              <FormControl
               style={stylee}
               // style={roundedInput}
                type="text"
                name="imei"
                value={employee.imei}
                onChange={handleChange}
                placeholder="Enter IMEI "
              />
              {errors.imei && (
                <span className="text-danger small">{errors.imei}</span>
              )}
            </FormGroup>
          </Col>
       
        <Col md={6}>
            <FormGroup>
              <ControlLabel style={{ marginBottom: "6px",marginTop: "10px" }}>VIN<span className="text-danger">*</span></ControlLabel>
              <FormControl
               style={stylee}
             //   style={roundedInput}
                type="text"
                name="vin"
                value={employee.vin}
                onChange={handleChange}
                placeholder="Enter VIN "
              />
              {errors.vin && (
                <span className="text-danger small">{errors.vin}</span>
              )}
            </FormGroup>
          </Col>
           </Row>
       {/* </Row> */}

        {/* Security question row */}
        <Row  style={{
            background: "#ECECEC",
            padding: "1rem",
            marginTop: "-2rem",
            borderRadius: " 5px",
          }}>
          <Col md={6}>
            <FormGroup>
              <ControlLabel style={{ marginBottom: "6px",marginTop: "10px" }}>
                Security Question<span className="text-danger">*</span>
              </ControlLabel>
              <FormControl
               style={stylee}
                //style={roundedInput}
                componentClass="select"
                name="selectedQuestion"
                value={employee.selectedQuestion}
                onChange={handleChange}
              >
                <option value="">-- Select a question --</option>
                {employee.securityQuestion.map((q, index) => (
                  <option key={index} value={q}>
                    {q}
                  </option>
                ))}
              </FormControl>
              {errors.selectedQuestion && (
                <span className="text-danger small">
                  {errors.selectedQuestion}
                </span>
              )}
            </FormGroup>
          </Col>

          <Col md={6}>
            <FormGroup>
              <ControlLabel style={{ marginBottom: "6px",marginTop: "10px" }}>
                Answer<span className="text-danger">*</span>
              </ControlLabel>
              <FormControl
               style={stylee}
                //style={roundedInput}
                type="text"
                name="answer"
                value={employee.answer}
                onChange={handleChange}
                placeholder="Enter answer"
              />
              {errors.answer && (
                <span className="text-danger small">{errors.answer}</span>
              )}
            </FormGroup>
          </Col>
        </Row>

        {/* Password row */}
        <Row  style={{
            background: "#ECECEC",
            padding: "1rem",
            marginTop: "-2rem",
            borderRadius: " 5px",
          }}>
          <Col md={6}>
            <FormGroup>
              <ControlLabel style={{ marginBottom: "6px",marginTop: "10px" }}>
                Password<span className="text-danger">*</span>
              </ControlLabel>
              <FormControl
               style={stylee}
              
                //style={roundedInput}
                type="password"
                name="password"
                value={employee.password}
                onChange={handleChange}
                placeholder="Enter password"
              />
              {errors.password && (
                <span className="text-danger small">{errors.password}</span>
              )}
            </FormGroup>
          </Col>

          <Col md={6}>
            <FormGroup>
              <ControlLabel style={{ marginBottom: "6px",marginTop: "10px" }}>
                Confirm Password<span className="text-danger">*</span>
              </ControlLabel>
              <FormControl
               style={stylee}
                //style={roundedInput}
                type="password"
                name="confirmPassword"
                value={employee.confirmPassword}
                onChange={handleChange}
                placeholder="Confirm password"
              />
              {errors.confirmPassword && (
                <span className="text-danger small">
                  {errors.confirmPassword}
                </span>
              )}
            </FormGroup>
          </Col>
        </Row>
    <Row style={{
            background: "#ECECEC",
            padding: "1rem",
            marginTop: "-2rem",
            borderRadius: " 5px",
          }}>
 <div className="text-center mt-1">
          <Button
            type="submit"
            bsStyle="primary"
            style={{
                  backgroundColor: "rgb(29, 117, 189)",
                  color: "rgb(255, 255,255)",
                  borderRadius: "12px",
                  padding: "0.3rem 3rem 0.3rem 3rem",
                }}
          >
            Submit
          </Button>
        </div>
    </Row>
       
      </form>
    </div>
    </>
  );
};

export default AddEmployee;
